import { useLazyQuery } from "@apollo/client";
import { getSearchObjectives } from "src/queries/objectives.graphql";

/**
 * Hook to fetch objectives when a branch is expanded
 * Uses lazy query to fetch on demand
 * @param {Function} onCompleted - Callback function when data loads successfully
 * @returns {Array} [loadBranch function, query result]
 */
const useLoadObjectiveBranch = (onCompleted) => {
  const [loadBranch, queryResult] = useLazyQuery(getSearchObjectives, {
    onCompleted: (data) => {
      if (onCompleted) {
        onCompleted(data, { isRootLoad: false });
      }
    },
  });

  /**
   * Load objectives for a specific branch
   * @param {Object} options - Query options
   * @param {String[]} options.objectiveIds - Array of objective IDs to fetch
   * @param {Number} options.maxChildDepth - How deep to fetch child objectives
   * @param {Object} options.inputOverrides - Override default input values
   */
  const loadObjectiveBranchWithParams = ({
    objectiveIds = [],
    maxChildDepth = 1,
    inputOverrides = {},
  } = {}) => {
    return loadBranch({
      variables: {
        input: {
          filter: {
            objectiveIds,
            onlyTopLevelObjectives: false,
          },
          excludeBaseObjectives: true,
          includeChildObjectives: true,
          includeParentObjectives: false,
          maxChildDepth,
          ...inputOverrides,
        },
      },
    });
  };

  return [loadObjectiveBranchWithParams, queryResult];
};

export default useLoadObjectiveBranch;
